import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_PRODUCAO = [
  {
    module: 'PROD_PECA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  },
  {
    module: 'PROD_MODELO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'linha_producao.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'vinculada_a_tpf'
      }
    ]
  },
  {
    module: 'PROD_SERVICO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'valor'
      },
      {
        active: true,
        removable: true,
        field: 'categoria_servico.descricao'
      }
    ]
  },
  {
    module: 'PROD_LINHA_PRODUCAO',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
      // {
      // active: true,
      // removable: true,
      //   field: 'mao_obra.descricao',
      // }
    ]
  },
  {
    module: 'PROD_ETAPA',
    colunas: [
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'posicao'
      },
      {
        active: true,
        removable: true,
        field: 'tempo_medio_duracao_dias'
      }
    ]
  },
  {
    module: 'PROD_PROCESSO',
    colunas: [
      // {
      // active: true,
      // removable: true,
      //   field: 'posicao',
      // },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'gerencia_partes'
      },
      {
        active: true,
        removable: true,
        field: 'posicao'
      },
      {
        active: true,
        removable: true,
        field: 'tempo_medio_duracao_dias'
      }
    ]
  },
  {
    module: 'PROD_CATEGORIA_SERVICO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'etapa.descricao'
      }
    ]
  },
  {
    module: 'PROD_PRIORIDADE',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'posicao'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_dias'
      },
      {
        active: true,
        removable: true,
        field: 'observacao'
      },
      {
        active: true,
        removable: true,
        field: 'padrao'
      }
    ]
  },
  {
    module: 'PROD_NIVEL',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      },
      {
        active: true,
        removable: true,
        field: 'qtd_dias'
      },
      {
        active: true,
        removable: true,
        field: 'observacao'
      },
      {
        active: true,
        removable: true,
        field: 'padrao'
      }
    ]
  },
  {
    module: 'PROD_TIPO_ERRO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'codigo'
      },
      {
        active: true,
        removable: false,
        field: 'descricao'
      }
    ]
  }
] as IColunasSettingsUser[];
